import React from "react";

const collaborationFocus = [
  {
    label: "Research validation",
    text: "Work with academic partners to evaluate models, datasets, and responsible AI methods.",
  },
  {
    label: "Field deployment",
    text: "Pilot products in education and care settings where real-world context matters.",
  },
  {
    label: "Global impact",
    text: "Build cross-border partnerships that make AI tools more useful and scalable.",
  },
];

const partnerDescriptions = {
  MBZUAI: "AI research and innovation ecosystem",
  CMU: "Learning science, AI, and technology research",
  "The University of Sydney": "International research collaboration",
  Conahcyt: "Data support for research and model development",
};

export const Gallery = (props) => {
  const partners = props.data || [];

  return (
    <section id="portfolio" className="collaboration-section">
      <div className="container collaboration-shell">
        <div className="collaboration-layout">
          <div className="collaboration-copy">
            <p className="section-kicker">Global Network</p>
            <h2>Collaboration</h2>
            <p className="collaboration-lede">
              We partner with research institutions and innovation networks to
              move responsible AI from validated research into products for
              education, families, and care teams.
            </p>

            <div className="collaboration-focus-list">
              {collaborationFocus.map((item) => (
                <article className="collaboration-focus" key={item.label}>
                  <span>{item.label}</span>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="collaboration-panel">
            <div className="collaboration-panel-header">
              <span>Partner Ecosystem</span>
              <p>Research, validation, and deployment support.</p>
            </div>

            <div className="collaboration-grid" aria-label="CradleAI collaborators">
              {partners.length
                ? partners.map((partner, index) => (
                    <article
                      key={`${partner.title}-${index}`}
                      className="collaboration-item"
                    >
                      <div className="collaboration-logo-box">
                        <img src={partner.smallImage} alt={`${partner.title} logo`} />
                      </div>
                      <div className="collaboration-partner-copy">
                        <span>{`0${index + 1}`}</span>
                        <h3>{partner.title}</h3>
                        <p>
                          {partnerDescriptions[partner.title] ||
                            "Research and innovation partner"}
                        </p>
                      </div>
                    </article>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
